<template lang="pug">
  #warning
    v-container(fluid)
      v-dialog(v-model="active" max-width="500" persistent)
        v-card
          v-card-title.headline
            v-icon(color="yellow darken-2") warning
            span ¿Revocar permiso?
            v-card-text Al revocar este permiso se perdera acceso a la sección de usuarios.
          v-card-actions
            v-spacer
            v-btn(color="red darken-1" flat @click.native="discard()") Cancelar
            v-btn(color="green darken-1" flat @click.native="agree()") Aceptar

</template>
<script>
/**
 * @todo:
 * 1. Upload img -> selectedUser.profileImg
 * 2. Get permissions and role options from api
 */

export default {
  name: "LoseAccesDialog",
  data() {
    return {
      active: false,
      resolve: undefined
    };
  },
  methods : {
    pop(){
      this.active = true;
      return new Promise((resolve, reject) => {
        console.log(resolve);
        this.resolve = resolve;
      });
    },
    agree(){
      this.active = false;
      this.$router.push('/');
      this.resolve(true);
    },
    discard(){
      this.active = false;
      this.$router.push('users');
      this.resolve(false);
    }
  }
}
</script>
<style lang="scss" scoped>
  .headline {
    font-size: 20px;
    span {
      color: #ffbf00;
      margin-left: 5px;
    }
  }
</style>